import { ExportButton } from '@/common/buttons/ExportButton';
import { TitleButton } from '@/common/buttons/TitleButton';
import { KrCard } from '@/common/card/KrCard';
import { FilterContainer } from '@/common/dashboard/FilterContainer';
import { useDialog } from '@/common/dialog/DialogContext';
import { Form } from '@/common/form/Form';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { ContentBox } from '@/common/layout/ContentBox';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { SaleStatusDefinitionsDialog } from '@/sc/entities/indirSale/dashboard/SaleStatusDefinitionsDialog';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { DirSaleTrendChart } from './DirSaleTrendChart';
import { DirSaleTrendGraph } from './DirSaleTrendGraph';

export const DirSaleFinDashboard = () => {
  const rsrc = useRsrc();

  const { openDialog } = useDialog();
  const { navState } = useNavState();

  const [fieldDefs, setFieldDefs] = useState();
  const [formValues, setFormValues] = useNavStateSync('formValues');

  const [totalValues, setTotalValues] = useState();

  useEffect(() => {
    rsrc
      .data('sc', 'DIR_SALE_DASHBOARD_FILTERS_DATA_PLUGIN', { periodicity: formValues?.periodicity ?? 'MONTH' })
      .then((res) => {
        setFieldDefs([
          { field: 'invPeriodId', displayName: 'Invoice Period', type: 'DROPDOWN', values: res.periods },
          {
            field: 'periodicity',
            displayName: 'Periodicity',
            type: 'DROPDOWN',
            values: [
              { value: 'MONTH', displayName: 'Month' },
              { value: 'QUARTER', displayName: 'Quarter' },
            ],
          },
          { field: 'prodIds', displayName: 'Products', type: 'TREE', treeData: res.prodTreeData },
        ]);

        setTotalValues({
          totalProdIds: res.prodIds,
        });

        if (!navState.formValues || !res.periods.map((p) => p.value).includes(formValues.invPeriodId)) {
          setFormValues({
            invPeriodId: res.periods[0].value,
            periodicity: formValues?.periodicity ?? 'MONTH',
            prodIds: formValues?.prodIds ?? res.prodIds,
          });
        }
      });
  }, [formValues?.periodicity]);

  const openDefinitionsDialog = () => {
    openDialog(SaleStatusDefinitionsDialog);
  };

  const formatPeriodicity = (periodicity) => {
    switch (periodicity) {
      case 'DAY':
        return 'Daily';
      case 'MONTH':
        return 'Monthly';
      case 'QUARTER':
        return 'Quarterly';
      default:
        return '';
    }
  };

  if (!fieldDefs) {
    return;
  }

  return (
    <ContentBox>
      {/* Title */}
      <Box
        sx={{
          mb: 1,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <Title icon={fas.faTasks} title="Direct Sale Dashboard" />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <TitleButton
            key="comparePolFormulaButton"
            icon={fas.faInfoCircle}
            toolTip="View Definitions"
            onClick={openDefinitionsDialog}
          />
          <ExportButton />
        </Box>
      </Box>

      {/* Filters */}
      <Form fieldDefs={fieldDefs} formValues={formValues} setFormValues={setFormValues} container={FilterContainer} />

      <SpacerLayout>
        <Spacer vertical>
          {/* Row 1 */}
          <Spacer weights={[1, 1]}>
            <KrCard title={`${formatPeriodicity(formValues?.periodicity)} Sold Trends`} sx={{ flex: 1 }}>
              <DirSaleTrendChart formValues={formValues} totalValues={totalValues} />
            </KrCard>
          </Spacer>

          {/* Row 2 */}
          <Spacer weights={[1, 2]}>
            <KrCard title="YoY Sold Trends">
              <DirSaleTrendGraph formValues={formValues} totalValues={totalValues} />
            </KrCard>
          </Spacer>
        </Spacer>
      </SpacerLayout>
    </ContentBox>
  );
};
